import { type ReactElement } from 'react';
import { OperatorProfilePage } from '@vello/web-theme';
import { useAdmin } from '../session';
import { useT } from '../i18n/provider';
import { useVocab } from '../i18n/vocab';
import { LANGS } from '../i18n/messages';

/**
 * "Meu perfil" (D806, doc 35 §3.2): the operator's own page, opened from the operator menu. The page is the shared one of
 * `@vello/web-theme`; the Admin gives it its language, its vocabulary and the api-client groups, and takes the account back after a change
 * so the sidebar's name and photo follow.
 */
export function ProfileScreen(): ReactElement {
  const { runtime, me, setMe } = useAdmin();
  const { t, lang, setLang } = useT();
  const vocab = useVocab();
  return <OperatorProfilePage t={t} vocab={vocab} account={runtime.auth} self={runtime.operatorAuth} lang={lang} langs={LANGS} setLang={setLang} {...(me !== undefined ? { initialMe: me } : {})} {...(setMe !== undefined ? { onAccountChanged: setMe } : {})} />;
}
